module.exports = __webpack_public_path__ + "static/media/5.14655fa2.jpg";